<template>
  <div class="content-page">
    <slot v-if="isLoaded">
      <component
        v-for="(item, index) in gblocks"
        :key="index"
        :is="item.blockName.replace('acf/', '')"
        :content="item.attrs"
        :id="item.blockName.replace('acf/', '')"
      />
    </slot>

    <slot v-else>
      <TheHeader />

      <div class="componata-container">
        <div class="content-page__placeholder">
          <content-placeholders :rounded="true" :centered="true">
            <content-placeholders-heading />
            <content-placeholders-img />
          </content-placeholders>
        </div>
      </div>
    </slot>

    <TheFooter />
  </div>
</template>

<script>
import axios from 'axios';
import AOS from 'aos';
import 'aos/dist/aos.css';

import TheHeader from '@/components/TheHeader';
import TheFooter from '@/components/TheFooter';

export default {
  name: 'ContentPage',
  components: {
    hero: () => import('@/components/Pages/Hero'),
    'business-features': () => import('@/components/Pages/BusinessFeatures'),
    comparison: () => import('@/components/Pages/Comparison'),
    'presents-catalog': () => import('@/components/Pages/Catalog'),
    'custom-presents': () => import('@/components/Pages/CustomPresents'),
    testimonials: () => import('@/components/Pages/Testimonials'),
    faq: () => import('@/components/Pages/Faq'),
    contact: () => import('@/components/Pages/Contact'),
    TheHeader,
    TheFooter
  },
  data () {
    return {
      content: {},
      isLoaded: false
    };
  },
  methods: {
    init () {
      // this.$store.commit('setGlobalLoading', true);

      axios
        .get(
          `${process.env.VUE_APP_BASE_URL}/wp-json/wp/v2/pages?slug=${this.$route.params.slug}`
        )
        .then((response) => {
          if (!response.data.length) {
            this.$router.push('/404');
          }

          if (response.data[0]) {
            this.content = response.data[0];
            this.isLoaded = true;
          }

          // this.$store.commit('setGlobalLoading', false);
        });
    }
  },
  computed: {
    gblocks () {
      return this.content.gblocks.filter(item => {
        return item.blockName.includes('acf/');
      });
    }
  },
  created () {
    this.init();
  },
  mounted () {
    AOS.init({
      once: true,
      duration: 600
    });

    this.$root.$on('AOSRefresh', () => {
      AOS.refresh();
    });
  },
  metaInfo () {
    if (this.content.title) {
      return {
        title: this.content.title.rendered
      };
    }
  }
};
</script>

<style lang="scss">
@import '@/assets/styles/lib/playfair-display-webfont/playfair-display';

</style>

<style lang="scss" scoped>
/**
 * Content Page
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Wrapper for content pages coming from WP
 * @since 2022-06-28
**/

$component: 'content-page';

.#{$component} {
  &__placeholder {
    width: 70%;
    margin: 0 auto;
    @include padding(map-get($spacers, 6) 0);

    ::v-deep .vue-content-placeholders {
      &-heading__title {
        @include rfs(3rem, height);
      }

      &-heading__subtitle {
        @include rfs(1.4rem, height);
      }

      &-img {
        @include rfs(20rem, height);
      }
    }
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
